<template>
  <div>
    <div class="footer">
      <div class="part1">
        <div class="nav_foot">
          <div class="inner">
            <a @click="toWorkDetailx('481468df-77a8-4d5a-8e3a-38e585f8640c')">双勾</a>
            <a @click="toWorkDetail('481468df-77a8-4d5a-8e3a-38e585f8640c','拓本')">拓本</a>
            <a @click="toWorkDetail('481468df-77a8-4d5a-8e3a-38e585f8640c','墨本')">墨本</a>
            <a @click="toWorkDetail('481468df-77a8-4d5a-8e3a-38e585f8640c','七彩')">彩本</a>
            <a @click="toWorkDetail('481468df-77a8-4d5a-8e3a-38e585f8640c','')">定制孤本</a>
            <a @click="toWorkDetail('481468df-77a8-4d5a-8e3a-38e585f8640c','')">极品收藏</a>
            <a @click="toWorkList('书法集')">书法集</a>
            <a @click="toWorkList('绘画集')">绘画集</a>
            <a @click="toWorkList('清鉴集')">清鉴集</a>
            <!--            <a @click="toWorkDetail('481468df-77a8-4d5a-8e3a-38e585f8640c','')">矢量图</a>-->
            <!--            <a @click="toWorkDetail('481468df-77a8-4d5a-8e3a-38e585f8640c','')">电子书</a>-->
            <a @click="toWorkDetail('481468df-77a8-4d5a-8e3a-38e585f8640c','')">加盟</a>
            <a @click="toWorkDetail('481468df-77a8-4d5a-8e3a-38e585f8640c','')">公益捐赠</a>
          </div>
        </div>
      </div>
      <div class="part2">
        <div>
          <div class="contact-info">
            <div class="contact-info-item">
              <h3>翰墨鉴藏</h3>
              <p>QQ:260008100</p>
            </div>
            <div class="contact-info-item">
              <h3>再论兰亭</h3>
              <p>18963697620</p>
            </div>
            <div class="contact-info-item">
              <h3>版权合作</h3>
              <p>18963697620</p>
            </div>
            <div class="contact-info-item">
              <h3>技术支持</h3>
              <p>0512-58812080</p>
            </div>
          </div>
          <div class="logo-info">
            <div class="logo">
              <a href="/WorksList?type=书法集">
                <img class="logo-img" src="../eiuov-ui/_ei-footer/凌烟阁大法帖（黄庭坚体）白.png" title="" alt="">
              </a>
            </div>
            <div class="logo logo-second">
              <a href="/WorksList?type=绘画集">
                <img class="logo-img" src="../eiuov-ui/_ei-footer/凌烟阁大画谱（黄庭坚体）白.png" title="" alt="">
              </a>
            </div>
            <div class="logo2">
              <a href="/WorksList?type=清鉴集">
                <img class="logo-img" src="../eiuov-ui/_ei-footer/凌烟阁清鉴集（黄庭坚体）白.png" title="" alt="">
              </a>
            </div>
            <!--            <div class="work-time">
                          <img src="./image/work_ico.png">
                          <span>服务热线(8:00-17:30)</span>
                        </div>-->
          </div>
          <div class="qrcode-info">
            <div class="inline-block ta-c mr-25">
              <img class="block qrcode-img" src="./_ei-footer/凌烟阁-二维码.png" title="" alt="">
              <span>凌烟阁 官网</span>
            </div>
            <div class="inline-block ta-c mr-25">
              <img class="block qrcode-img" src="./_ei-footer/EIUOV-二维码.png" title="" alt="">
              <span>EIUOV 官网</span>
            </div>
          </div>
        </div>
        <div class="website-info">
          <span>
            <a href="/CopyRight" target="_blank">版权所有©
              <span>凌烟阁大法帖</span>
              |
               <span>凌烟阁大画谱</span>
            </a>
          </span>
          |
          <span>
            <a href="https://map.baidu.com/search/%E6%B1%9F%E8%8B%8F%E7%9C%81%E8%8B%8F%E5%B7%9E%E5%B8%82%E5%BC%A0%E5%AE%B6%E6%B8%AF%E5%B8%82%E5%8D%97%E4%B8%B0%E9%95%87/@13434430.487258535,3724907.823855518,19z?querytype=s&da_src=shareurl&wd=%E6%B1%9F%E8%8B%8F%E7%9C%81%E8%8B%8F%E5%B7%9E%E5%B8%82%E5%BC%A0%E5%AE%B6%E6%B8%AF%E5%B8%82%E5%8D%97%E4%B8%B0%E9%95%87&c=317&src=0&pn=0&sug=0&l=13&b=(13382189.838620076,3707666.493046595;13443577.881630829,3737625.136953405)&from=webmap&biz_forward=%7B%22scaler%22:1,%22styles%22:%22pl%22%7D&seckey=303db4e1ad1cc0983424d5aa522448d9c8cfac3d0a1cb84bb51835caadf84b23a7ed9a2857ea4739bd4bd44e1e61e84fd749f0484e5849f45eac39db12d335532f10868d616026d1202b96d772c5f2a0dc1c6e36db5be9489fc24d236ea17abd864172bfaa36e62f52e75574c65c91361786f788775351e331763520639fe1c6e51b0086d9ce27e08a0f8ed5789ea9303eef14ed8dfa70a685ebf65cbe5d5e55d3342233cfde03a181b9c9c46a801461cca5dbf6ff74f80d28105e0b6e38d549c350be6342414b1d10fbf0c20fc90fd058cdea233f11a696eb0a150bf66257e8a79817b43199d95c1ed087c3d3eda9d7&device_ratio=1"
               target="_blank">地址：
              <span>江苏省苏州市张家港市南丰永联小镇永琪园1幢</span>
          </a>
          </span>
          <span><a href="https://www.youbianku.com/215628" target="_blank"
                   class="mail-code">邮编：<span>215628</span></a></span>
          |
          <span><a href="https://mail.qq.com/" target="_blank">反馈意见：<span>xghao8877@qq.com</span></a></span>
          &nbsp;|&nbsp;&nbsp;&nbsp;
          <span><a href="https://beian.miit.gov.cn/#/Integrated/index"
                   target="_blank">网站备案：<span>苏ICP备2022022746号-1</span></a></span>
          <span></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EiFooter',

  methods: {
    toWorkDetail (guid, style) {
      this.$router.push({
        path: '/WorksDetail',
        query: {
          guid: guid,
          stytle: style
        },
      })
    },
    toWorkDetailx (guid) {
      this.$router.push({
        path: '/WorksDetail',
        query: { guid: guid },
      })
    },
    toWorkList (type) {
      this.$router.push({
        path: '/WorksList',
        query: { type: type },
      })
      this.$router.go(0)
    }
  }
}

</script>
<style scoped lang="scss">
.footer {
  min-width: 80%;
  margin-top: 50px;
  background: #302a29;
  color: #fff;
  position: relative;
  overflow: hidden;

  .part1 {
    padding-bottom: 10px;
    align-items: flex-end;
    background: #94070a;
    color: #fff;

    .nav_foot {
      padding-bottom: 10px;
      overflow: hidden;
      text-align: center;

      a {
        font-size: 16px;
        padding: 20px 0 0 0;
        text-align: center;
        width: 110px;
        border-left: 1px solid rgba(255, 255, 255, 0.2);
        display: inline-block;

        &:hover {
          opacity: 0.8;
        }
      }
    }
  }

  .part2 {
    padding: 15px 0;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-direction: column;
    flex-direction: column;
    -ms-flex-align: center;
    align-items: center;

    .contact-info {
      display: inline-block;
      width: 380px;
      margin-left: 50px;
      margin-bottom: 30px;

      .contact-info-item {
        display: inline-block;
        width: 190px;
        margin-top: 10px;

        h3 {
          height: 26px;
          line-height: 26px;
          color: #fff;
        }

        p {
          height: 35px;
          line-height: 35px;
          font-size: 24px;
          color: #CE324A;
        }
      }
    }

    .logo-info {
      position: relative;
      display: inline-block;
      width: 500px;
      text-align: center;
      height: 100px;

      // 各 logo 图片高度（px 由 postcss 自动转 vw）
      .logo-img {
        height: 50px;
      }

      .logo-second {
        margin-left: 470px;
        margin-top: -55px;
      }

      .logo {
      }

      .logo2 {
        position: absolute;
        margin-top: -123px;
        margin-left: 300px;
      }

      .work-time {
        margin-top: -73px;
        width: 220px;
        margin-left: -400px;

        img {
          vertical-align: middle;
          margin-right: 40px;
          margin-top: 106px;
        }

        span {
          position: absolute;
          padding-top: 103px;
          margin-left: -30px;
          vertical-align: middle;
        }
      }
    }

    .qrcode-info {
      display: inline-block;
      width: 350px;
      text-align: center;
      margin-left: 350px;

      .qrcode-img {
        height: 100px;
      }
    }

    .website-info {
      margin-top: -15px;
      margin-bottom: 15px;
      color: rgba(255, 255, 255, 0.1);
      font-size: 16px;
      width: 100%;
      text-align: center;


      > span {
        margin: 0 20px;
        color: #fff;
        font-size: 16px;
      }

      .mail-code {
        margin-left: -30px;
      }

      a {
        &:hover span {
          color: #3e77b9;
        }
      }


    }
  }
}
</style>
